import { render } from "./MenuTree.vue?vue&type=template&id=d7daa69e&scoped=true"
import script from "./MenuTree.vue?vue&type=script&lang=js"
export * from "./MenuTree.vue?vue&type=script&lang=js"

import "./MenuTree.vue?vue&type=style&index=0&id=d7daa69e&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src4192554447/src/github.com/DeepAngle/DDR-Atlas-Proto/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d7daa69e"]])

export default __exports__